import { render, staticRenderFns } from "./el-upload.vue?vue&type=template&id=6db1778f&lang=pug&"
import script from "./el-upload.vue?vue&type=script&lang=ts&"
export * from "./el-upload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports